import { Plug } from "lucide-react";
import { t } from "@/i18n";

// Selección de Conexión + Modelo. Los modelos dependen de la capacidad (image|video).
// Los modelos con pendingIntegration=true se muestran deshabilitados en el selector.
const ConnectionModelPicker = ({
  connections,
  connectionId,
  onConnection,
  models,
  modelId,
  onModel,
  testPrefix,
  loading = false,
  error = false,
}) => {
  const availableModels = [];
  const pricePendingModels = [];
  const pendingIntegrationModels = [];

  for (const m of models) {
    const isPending = m.pendingIntegration === true || m.pending_integration === true;
    const isPricePending = !isPending && (m.pricePending === true || m.price_pending === true || (m.generationAvailable === false && !isPending));
    if (isPending) {
      pendingIntegrationModels.push(m);
    } else if (isPricePending) {
      pricePendingModels.push(m);
    } else {
      availableModels.push(m);
    }
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      <label>
        <span className="mb-1.5 flex items-center gap-1.5 text-sm font-medium"><Plug size={13} />{t.tools.connection}</span>
        <select
          data-testid={`${testPrefix}-connection`}
          className="v-input"
          value={connectionId}
          disabled={loading || connections.length === 1}
          onChange={(e) => onConnection(e.target.value)}
          aria-label={t.tools.connection}
        >
          {loading ? (
            <option value="">{t.tools?.loadingConnections || "Cargando conexiones..."}</option>
          ) : error ? (
            <option value="">{t.tools?.connectionsError || "Error al consultar conexiones (pulsa reintentar)"}</option>
          ) : connections.length === 0 || (!connectionId && connections.length > 1) ? (
            <option value="">{t.connections.none}</option>
          ) : null}
          {connections.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </label>
      <label>
        <span className="mb-1.5 block text-sm font-medium">{t.tools.model}</span>
        <select
          data-testid={`${testPrefix}-model`}
          className="v-input"
          value={modelId}
          disabled={models.length <= 1}
          onChange={(e) => onModel(e.target.value)}
          aria-label={t.tools.model}
        >
          {availableModels.length > 0 && (
            <optgroup label="Disponibles">
              {availableModels.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.label || m.id}
                </option>
              ))}
            </optgroup>
          )}

          {pricePendingModels.length > 0 && (
            <optgroup label="Integrados con precio pendiente">
              {pricePendingModels.map((m) => (
                <option key={m.id} value={m.id} disabled>
                  {`${m.label || m.id} — Precio pendiente — generación no disponible`}
                </option>
              ))}
            </optgroup>
          )}

          {pendingIntegrationModels.length > 0 && (
            <optgroup label="Pendientes de integración">
              {pendingIntegrationModels.map((m) => (
                <option key={m.id} value={m.id} disabled>
                  {`${m.label || m.id} [Pendiente de integración]`}
                </option>
              ))}
            </optgroup>
          )}
        </select>
      </label>
    </div>
  );
};

export default ConnectionModelPicker;
